import {
    CREATE_USER_PHONE_REQUEST,
    REMOVE_USER_PHONE_REQUEST,
    CHANGE_USER_PHONE_REQUEST,
    GET_USER_PHONES_REQUEST_SUCCESS,
    CREATE_USER_PHONE_SUCCESS,
    CHANGE_USER_PHONE_SUCCESS,
    REMOVE_USER_PHONE_SUCCESS,
    GET_USER_PHONES_REQUEST_FAILURE,
    CHANGE_USER_PHONE_FAILURE,
    CREATE_USER_PHONE_FAILURE,
    REMOVE_USER_PHONE_FAILURE,
} from '../constants/user_phones.constants';

const initialState = {
    loading: false,
    phones: [],
    name: '',
    phone: '',
    error: null,
};

export const User_profile_phones_table = (state = initialState, action) => {
    switch (action.type) {
    case CREATE_USER_PHONE_REQUEST:
    case CHANGE_USER_PHONE_REQUEST:
    case REMOVE_USER_PHONE_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case CHANGE_USER_PHONE_SUCCESS:
    case CREATE_USER_PHONE_SUCCESS:
    case REMOVE_USER_PHONE_SUCCESS:
    case GET_USER_PHONES_REQUEST_SUCCESS:
        return {
            ...state,
            phones: action.payload,
            loading: false,
            name: '',
            phone: '',
        };
    case GET_USER_PHONES_REQUEST_FAILURE:
    case CHANGE_USER_PHONE_FAILURE:
    case CREATE_USER_PHONE_FAILURE:
    case REMOVE_USER_PHONE_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
        };
    case 'RESET_USER_PHONE_DATA':
        return {
            ...state,
            name: '',
            phone: '',
            _id: '',
        };
    case 'USER_PHONE_SET_HANDLER':
        return {
            ...state,
            name: action.name || (action.name === '' && []) || state.name,
            phone: action.phone || (action.phone === '' && []) || state.phone,
        };
    case 'SET_USER_PHONE_DATA':
        return {
            ...state,
            name: action.payload.name,
            phone: action.payload.phone,
            _id: action.payload._id,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/reducers/user_profile_phones.reducers.js